import moment from "moment";

const DASH = "-";

// `moduleUser.userInfo` stores names under language-suffixed keys
// (firstNameTh/lastNameTh, firstNameEn/lastNameEn) — the same fields the
// Navbar renders. Prefer Thai, fall back to English, then any legacy
// firstName/lastName. Returns DASH when no name is present.
function resolveName(user) {
  if (!user) return DASH;
  const first = user.firstNameTh || user.firstNameEn || user.firstName || "";
  const last = user.lastNameTh || user.lastNameEn || user.lastName || "";
  const full = `${first} ${last}`.trim();
  return full || DASH;
}

export function formatStamp(date) {
  return moment(date).format("YYYY-MM-DD HH:mm");
}

export function buildIdentityLines({ user, clinic, branch, now }) {
  if (!user) return [];
  const name = resolveName(user);
  const email = user.email || DASH;
  const clinicName = (clinic && clinic.name) || DASH;
  const branchName = (branch && branch.name) || DASH;
  // Three short lines instead of two long ones: a long name+email pair used to
  // overflow the fixed-width tile and overlap neighbouring tiles. Keeping name,
  // email, and the clinic/branch/timestamp on their own lines minimises width.
  return [
    name,
    email,
    `${clinicName} · ${branchName} · ${formatStamp(now)}`,
  ];
}

export function buildExportStamp({ user, now }) {
  const name = resolveName(user);
  const email = (user && user.email) || DASH;
  return `ส่งออกโดย: ${name} · ${email} · ${formatStamp(now)}`;
}

export function isPatientDocComponent(name, denylist) {
  if (!name || !Array.isArray(denylist)) return false;
  return denylist.includes(name);
}
